module.exports = __webpack_public_path__ + "static/img/trust-icon2.b77f6536.png";